<template>
  <v-container fluid>
    <v-card class="mb-6">
      <v-toolbar color="secondary" dark shaped>
        <h3 style="text-transform: uppercase; font-weight: 400">
          {{ $route.name }}
        </h3>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        <v-row class="mb-6">
          <v-col cols="12" sm="3" md="3">
            <Date
              @dateValue="[(filter.date = $event)]"
              label="Mês e Ano"
              type="month"
            />
          </v-col>
          <v-col cols="12" sm="9">
            <v-autocomplete
              :items="prefectures"
              label="Prefeitura:"
              v-model="filter.prefecture_id"
              item-value="prefecture_id"
              item-text="prefecture_social_name"
              @change="getCode(filter.prefecture_id)"
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              :items="codigos"
              label="Código da Unidade Gestora:"
              v-model="filter.cod"
              item-value="cod"
              item-text="cod"
            />
          </v-col>
        </v-row>
        <v-footer absolute rounded>
          <v-spacer />
          <v-btn
            color="secondary"
            class="mr-2"
            text
            :to="`/report/tce/situacao-frota/${filter.date?.substring(
              5
            )}/${filter.date?.substring(0, 4)}/${filter.prefecture_id}/${
              filter.cod
            }`"
            target="_blank"
            :disabled="
              filter.prefecture_id && filter.cod && filter.date ? false : true
            "
          >
            Gerar Relatório
          </v-btn>
          <v-btn
            color="secondary"
            class="mr-2"
            text
            @click="search"
            :disabled="isButtonDisabled"
          >
            FILTRAR
          </v-btn>
        </v-footer>
      </v-card-text>
    </v-card>

    <v-card>
      <v-toolbar color="secondary" dark shaped>
        <h3 style="text-transform: uppercase; font-weight: 400">Resultado</h3>
        <v-spacer />
        <v-btn
          class="mr-2"
          text
          @click="exportFile"
          :disabled="isButtonDisabled"
        >
          Exportar
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-data-table :loading="loader" :items="data" :headers="headers">
          <template v-slot:item.categoria="{ item }">
            <span>
              {{ item.categoria == 1 ? "Veículo" : "Máquina" }}
            </span>
          </template>
          <template v-slot:item.tipoSituacao="{ item }">
            <span>
              {{
                item.tipoSituacao == 1
                  ? "Em Uso"
                  : item.tipoSituacao == 2
                  ? "Em Manutenção"
                  : "Baixada"
              }}
            </span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Date from "@/components/InputDate.vue";
import Helpers from "@/mixins/helpers.js";
export default {
  components: { Date },
  mixins: [Helpers],
  data() {
    return {
      loader: false,
      data: [],
      prefectures: [],
      codigos: [],
      filter: {
        prefecture_id: null,
        date: null,
        cod: null,
      },
      headers: [
        { text: "Código da Unidade Gestora", value: "codUnidadeGestora" },
        { text: "Data da Situação da Frota ou Máquina", value: "data" },
        { text: "Tipo da Situação da Frota ou Máquina", value: "tipoSituacao" },
        { text: "Categoria do Veículo", value: "categoria" },
        { text: "Número da Placa da Frota", value: "codigo" },
      ],
    };
  },
  created() {
    this.Helpers;
    this.initialize();
  },
  computed: {
    isButtonDisabled() {
      return !(
        this.filter.prefecture_id &&
        this.filter.date &&
        this.filter.cod
      );
    },
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http.get("/prefectures").then((r) => (this.prefectures = r.data));
      this.loader = false;
      this.$store.dispatch("setLoader", this.loader);
    },
    getCode(prefecture_id) {
      this.$http(`/tce/codigo/${prefecture_id}`).then(
        (r) => (this.codigos = r.data)
      );
    },
    search() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(
          `/tce/situacao-frota/${
            this.filter.prefecture_id
          }/${this.filter.date.substring(0, 4)}/${this.filter.date.substring(
            5
          )}/${this.filter.cod}`
        )
        .then((res) => {
          this.data = res.data;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
          alert(e.message);
        });
    },
    exportFile() {
      const element = document.createElement("a");
      const content = this.data.map((value, index) => {
        if (index > 0) {
          return `\n${value.export}`;
        }
        return value.export;
      });

      const file = new Blob(content, { type: "text/plain" });
      element.href = URL.createObjectURL(file);
      element.download = `${this.filter.cod}${this.filter.date.substring(
        5
      )}${this.filter.date.substring(0, 4)}SituacaoFrota.txt`;
      document.body.appendChild(element);
      element.click();
    },
  },
};
</script>
